import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import ajax from '@/utils/ajax';

import { BillingItemEdit, BillingItemEditGroup } from '../components/RowEditor/types';

export const billingItemEditGroupRepository = {
  async createBillingItemEdit(host: string, edit: BillingItemEdit): Promise<BillingItemEditGroup> {
    const path = `${host}/api/billing/billing_item_edit_groups/`;
    const response = await ajax.post<
      BillingItemEdit,
      import('axios').AxiosResponse<BillingItemEditGroup>
    >({
      url: path,
      data: edit
    });

    return response.data;
  },
  async deleteBillingItemGroup(host: string, id: number): Promise<void> {
    const path = `${host}/api/billing/billing_item_edit_groups/${id}/`;
    await ajax.delete({ url: path });
  },
  async clearBillingItemEdits(host: string, billingItemIds: string[]): Promise<void> {
    const path = `${host}/api/billing/billing_item_edit_groups/clear_edits/`;
    await ajax.post({
      url: path,
      data: {
        billing_item_ids: billingItemIds
      }
    });
  }
};

const BillingItemEditRepository = (): {
  createBillingItemEdit: (edit: BillingItemEdit) => Promise<BillingItemEditGroup>;
  deleteBillingItemGroup: (id: number) => Promise<void>;
  clearBillingItemEdits: (billingItemIds: string[]) => Promise<void>;
} => {
  const { host } = useContext(AppContext);
  return {
    async createBillingItemEdit(edit: BillingItemEdit): Promise<BillingItemEditGroup> {
      return billingItemEditGroupRepository.createBillingItemEdit(host, edit);
    },
    async deleteBillingItemGroup(id: number): Promise<void> {
      return billingItemEditGroupRepository.deleteBillingItemGroup(host, id);
    },
    async clearBillingItemEdits(billingItemIds: string[]): Promise<void> {
      return billingItemEditGroupRepository.clearBillingItemEdits(host, billingItemIds);
    }
  };
};

export default BillingItemEditRepository;
